import { render, staticRenderFns } from "./ManagePlants.vue?vue&type=template&id=2026174a&"
import script from "./ManagePlants.vue?vue&type=script&lang=js&"
export * from "./ManagePlants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports